
import api from './api'

export default {
    
    get() {

        return api.get('/settings', {})
            .then( json => json.data)            
    },
}
